import { floatify } from 'lib/maths/mathUtils'
import { createSelector } from 'reselect'
import { isSpoofed } from 'selectors/featuresSelectors'
import getPayableAfterModifiers from './getPayableAfterModifiers'
import getDepositCalculations from './deposit/getDepositCalculations'
import getGiftCardPayAmount from './getGiftCardPayAmount'

const getCreditPayableAmount = createSelector(
  (state: App.State) => getPayableAfterModifiers(state),
  (state: App.State) => state.auth.account.creditsByCurrency[state.checkout.cart.currencyCode],
  (state: App.State) => isSpoofed(state),
  (state: App.State) => getDepositCalculations(state),
  (state: App.State) => state.checkout.payment.rebookingID,
  (state: App.State) => getGiftCardPayAmount(state),
  (payable, credits, isSpoofed, depositCalculations, rebookingID, giftCardPayAmount): number => {
    let maxCreditTotal: number
    const creditBalance = credits?.balance ?? 0
    if (isSpoofed && rebookingID) {
      maxCreditTotal = depositCalculations.maxDepositCreditAmount
    } else {
      maxCreditTotal = Math.min(creditBalance, payable)
    }

    maxCreditTotal = Math.min(maxCreditTotal, floatify(payable - giftCardPayAmount))

    return floatify(maxCreditTotal)
  },
)

export default getCreditPayableAmount
